import { Dispatch } from 'redux';
import { ActionType } from 'store/ActionType';
import { ThunkResult } from 'store/store';
import {
    createChangeAvailableLanguagesAction,
    createPreferredLanguageFetchFailureAction,
    createPreferredLanguageFetchRequestAction,
    createPreferredLanguageFetchSuccessAction,
} from 'store/Language/languageAction';
import { UsersApi } from 'services/ApiService/ServiceBoard/ServiceBoardApi';
import { getSGConnect } from 'core/services/common/sgConnect';
import { logError } from 'core/services/common/logging/logger';

export const changeAvailableLanguages = (languages: string[]): ThunkResult => {
    return async (
        dispatch: Dispatch<ActionType>,
    ) => {
        dispatch(createChangeAvailableLanguagesAction(languages));
    };
};

export const changePreferredLanguageAccountCenter = (language: string): ThunkResult => {
    return async (
        dispatch: Dispatch<ActionType>,
        _state,
    ) => {
        try {
            // for unkonwn reason, "sgwt-account-center" handle event "sgwt-account-center--language-changed" multiple times for one action
            // this is a security to avoid multiples calls
            if (_state().language.changePreferredLanguageIsFetching) {
                return;
            }

            dispatch(createPreferredLanguageFetchRequestAction());

            // preferredLanguage is stored in SGConnect claims
            // renew token to get updated claims in token
            const sgConnectPromise = new Promise<void>((resolve, reject) => {
                const autoRejectId = setTimeout(() => {
                    reject('Can\'t renew SGConnect authorization');
                }, 5000);
                getSGConnect().renewAuthorization(() => {
                    clearTimeout(autoRejectId);
                    resolve();
                });
            });
            await sgConnectPromise;
            dispatch(createPreferredLanguageFetchSuccessAction(language));
        } catch (error: unknown) {
            logError(error);
            dispatch(createPreferredLanguageFetchFailureAction());
        }
    };
};

export const changePreferredLanguageViaApi = (language: string): ThunkResult => {
    return async (dispatch: Dispatch<ActionType>) => {
        try {

            dispatch(createPreferredLanguageFetchRequestAction());

            await UsersApi.changeLanguage(language);

            const sgConnectPromise = new Promise<void>((resolve, reject) => {
                const autoRejectId = setTimeout(() => {
                    reject('Can\'t renew SGConnect authorization');
                }, 5000);

                getSGConnect().renewAuthorization(() => {
                    clearTimeout(autoRejectId);
                    resolve();
                });
            });

            await sgConnectPromise;

            dispatch(createPreferredLanguageFetchSuccessAction(language));

        } catch (error: unknown) {
            logError(error);
            dispatch(createPreferredLanguageFetchFailureAction());
        }
    };
};